export default {
  webUserInfo: {},//前台用户信息
  adminUserInfo:{},//后台用户信息
}
